module.exports = "/assets/data/48a4c030304684b2b64521a8320e3c05-DA16.data.json";